import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookmarkFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 16,
	viewBox: "0 0 12 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0 1.5C0 0.6875 0.65625 0 1.5 0H10.5C11.3125 0 12 0.6875 12 1.5V15.25C12 15.6875 11.6562 16 11.2188 16C11.0625 16 10.9062 15.9688 10.7812 15.875L6 12.5L1.1875 15.875C1.0625 15.9688 0.90625 16 0.75 16C0.3125 16 0 15.6875 0 15.25V1.5Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgBookmarkFilled);
export { ForwardRef as ReactComponent };
